import { fetchAuthSession } from '@aws-amplify/auth';
import type { TrafficSummaryResponse } from '@bpd/shared';

const TRAFFIC_SUMMARY_API_URL = import.meta.env.VITE_TRAFFIC_SUMMARY_API_URL;

export const trafficApi = {
  getSummary: async (days = 30): Promise<TrafficSummaryResponse | null> => {
    if (!TRAFFIC_SUMMARY_API_URL) return null;

    const session = await fetchAuthSession({ forceRefresh: false });
    const idToken = session.tokens?.idToken?.toString();
    if (!idToken) throw new Error('Not authenticated');

    const res = await fetch(`${TRAFFIC_SUMMARY_API_URL}?days=${days}`, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
    if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
    return (await res.json()) as TrafficSummaryResponse;
  },
};
